import React from "react";
import HealthCard from "./HealthCard";
import { formatNumber } from "../utils";

const PLACEHOLDER = {
  healthyPercent: 79,
  healthy: 81,
  attention: 14,
  critical: 7,
};

const VehicleCondition = ({ translate, data, loading, apiReady = false }) => {
  const payload = apiReady && data ? data : PLACEHOLDER;
  const healthy = Number(payload.healthy ?? 0);
  const attention = Number(payload.attention ?? payload.needsAttention ?? 0);
  const critical = Number(payload.critical ?? 0);
  const total = healthy + attention + critical || 1;
  const healthyPercent = Number(
    payload.healthyPercent ?? (healthy / total) * 100,
  );
  const circumference = 2 * Math.PI * 52;
  const healthyLen = (healthy / total) * circumference;
  const attentionLen = (attention / total) * circumference;
  const criticalLen = (critical / total) * circumference;

  return (
    <HealthCard
      className="fh-span-3"
      title={translate("vehicleConditionSafety") + " --> Api Pending"}
      subtitle={translate("vehicleConditionSafetySub")}
      loading={loading}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <svg width="140" height="140" viewBox="0 0 140 140">
          <circle
            cx="70"
            cy="70"
            r="52"
            fill="none"
            stroke="#5cb85c"
            strokeWidth="17"
            strokeDasharray={`${healthyLen} ${circumference}`}
            transform="rotate(-90 70 70)"
          />
          <circle
            cx="70"
            cy="70"
            r="52"
            fill="none"
            stroke="#f0ad2e"
            strokeWidth="17"
            strokeDasharray={`${attentionLen} ${circumference}`}
            strokeDashoffset={-healthyLen}
            transform="rotate(-90 70 70)"
          />
          <circle
            cx="70"
            cy="70"
            r="52"
            fill="none"
            stroke="#e0484c"
            strokeWidth="17"
            strokeDasharray={`${criticalLen} ${circumference}`}
            strokeDashoffset={-(healthyLen + attentionLen)}
            transform="rotate(-90 70 70)"
          />
          <text
            x="70"
            y="68"
            textAnchor="middle"
            fontSize="26"
            fontWeight="700"
            fill="#22303c"
          >
            {formatNumber(healthyPercent)}%
          </text>
          <text
            x="70"
            y="86"
            textAnchor="middle"
            fontSize="10.5"
            fill="#8a97a3"
          >
            {translate("healthy")}
          </text>
        </svg>
      </div>
      <div className="fh-legend">
        <span>
          <i className="fh-dot" style={{ background: "#5cb85c" }} />
          {translate("healthy")} — {formatNumber(healthy)}
        </span>
        <span>
          <i className="fh-dot" style={{ background: "#f0ad2e" }} />
          {translate("needsAttention")} — {formatNumber(attention)}
        </span>
        <span>
          <i className="fh-dot" style={{ background: "#e0484c" }} />
          {translate("critical")} — {formatNumber(critical)}
        </span>
      </div>
      {!apiReady ? (
        <div className="fh-coming-soon">{translate("apiPending")}</div>
      ) : null}
    </HealthCard>
  );
};

export default VehicleCondition;
